// babel-polyfill要放在最开始
import 'babel-polyfill';
import xss from 'xss';
import Vue from 'vue';
import App from './App.vue';
import router from './router/index';
import store from './store';
import i18n from '@/locale';
import axios from '@/libs/request/axios';
import importDirective from '@/directive';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import '@/libs/moment-timezone/moment-timezone-with-data';
import imgError from './libs/imgError';

// 数据方法扩展
import '@/libs/extend/Array';

// 自定义过滤方法
import './libs/filter';

// 引入全局样式
import './app.less';

// ant.design局部引入
import './libs/ant.design';

// 全局注册基础组件
import './components/baseComponents';

// 导入src/assets/icon目录下的所有svg
const req = require.context('./assets/icon', false, /\.svg$/);
const requireAll = requireContext => requireContext.keys().map(requireContext);
requireAll(req);

// axios挂载到Vue,可以使用this.axios调用
Vue.prototype.axios = axios;

// filter xss
Vue.prototype.xss = xss;

// 生产环境关掉提示
Vue.config.productionTip = false;

// 注册指令
importDirective(Vue);

// 美化滚动条
Vue.use(PerfectScrollbar);

Vue.prototype.$t = (key, value) => i18n.t(key, value);

// i18n方法 this.$t方法挂载到window
window.$t = (key, value) => i18n.t(key, value);

Vue.prototype.$console = window.$console = function(text, err) {
  console.log(
    `%c${text} %c${err}`,
    'background: #222; color: #bada55;',
    'background: #222; color: red;'
  );
};

// 图片加载失败时显示默认图片
window.addEventListener('error', imgError, true);

const NODE_ENV = (process.env.NODE_ENV || '').trim();
if (NODE_ENV === 'production') {
  window.onerror = function(msg, url, lineNo, columnNo, error) {
    var string = msg.toLowerCase();
    var substring = 'script error';
    if (string.indexOf(substring) > -1) {
      console.error('Script Error: See Browser Console for Detail');
    } else {
      var message = [
        'Message: ' + msg,
        'URL: ' + url,
        'Line: ' + lineNo,
        'Column: ' + columnNo,
        'Error object: ' + JSON.stringify(error),
      ].join(' - ');
      console.error(JSON.stringify(message));
    }
    return true;
  };
}

// resize
// window.onresize = debounce(function() {
//   window.location.reload();
// }, 200);

// 挂载实例方法到window
new Vue({
  router,
  store,
  axios,
  i18n,
  render: h => h(App),
}).$mount('#root');
